var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.334 22L7.665 22C4.26137 22 2 19.5707 2 16.084L2 7.916C2 4.43296 4.2681 2 7.665 2L16.334 2C19.7378 2 22 4.4295 22 7.916L22 16.084C22 19.5705 19.7378 22 16.334 22ZM7.665 20.5L16.334 20.5C18.8845 20.5 20.5 18.765 20.5 16.084L20.5 7.916C20.5 5.23496 18.8845 3.5 16.334 3.5L7.665 3.5C5.12096 3.5 3.5 5.23878 3.5 7.916L3.5 16.084C3.5 18.7653 5.11476 20.5 7.665 20.5ZM12 16.836C11.6203 16.836 11.3065 16.5538 11.2568 16.1878L11.25 16.086L11.25 9.73081L8.78346 12.2069C8.51776 12.4737 8.10115 12.4988 7.80707 12.2816L7.7228 12.2092C7.45597 11.9435 7.43087 11.5269 7.6481 11.2328L7.72054 11.1485L11.4685 7.3845C11.735 7.11686 12.1532 7.09253 12.4472 7.31151L12.4503 7.31421C12.4782 7.33516 12.5046 7.358 12.5292 7.38255L12.5315 7.3845L16.2795 11.1485C16.5717 11.442 16.5707 11.9169 16.2772 12.2092C16.0104 12.4749 15.5937 12.4982 15.3005 12.2797L15.2165 12.2069L12.75 9.72942L12.75 16.086C12.75 16.5002 12.4142 16.836 12 16.836Z",
    fill: "#525454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow_up.c5043e0a0825e8b00fe4d52d29ebf93b.svg";
export { ForwardRef as ReactComponent };